import { ActionTypes } from "../Constants/ActionTypes";

export const updatePlaylistMedia = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.UPDATE_PLAYLIST_MEDIA,
    payload: payload,
  });
};

export const setPlaylistData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_PLAYLIST_DATA,
    payload: payload,
  });
};

export const setVideoEditPopupData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.VIDEO_EDIT_POPUP_DATA,
    payload: payload,
  });
};

export const openVideoEditPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_VIDEO_EDIT_POPUP,
    payload: payload,
  });
};

export const setProgressBar = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_PROGRESS_BAR,
    payload: payload,
  });
};

export const setFinishedEdit = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_FINISHED_EDIT,
    payload: payload,
  });
};

export const setBackDrop = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_BACKDROP,
    payload: payload,
  });
};

export const setEditedVideoPosition = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDITED_VIDEO_POSITION,
    payload: payload,
  });
};

export const setSelectedVideoPath = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_VIDEO_PATH,
    payload: payload,
  });
};

export const setVideoEditData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_VIDEO_EDIT_DATA,
    payload: payload,
  });
};

export const setText = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_TEXT,
    payload: payload,
  });
};

export const setEditedVideoName = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDITED_VIDEO_NAME,
    payload: payload,
  });
};

export const setStartTime = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_START_TIME,
    payload: payload,
  });
};

export const setDuration = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_DURATION,
    payload: payload,
  });
};

export const setVideoPathForTrim = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_VIDEO_PATH_FOR_TRIM,
    payload: payload,
  });
};

export const setEditIconClick = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.HANDLE_EDIT_ICON_CLICK,
    payload: payload,
  });
};

export const setShowSlider = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SHOW_SLIDER,
    payload: payload,
  });
};

export const setShowTrimmer = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SHOW_TRIMMER,
    payload: payload,
  });
};

export const setEditIcons = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDIT_ICONS,
    payload: payload,
  });
};

export const setDataAfterVideoEdit = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_DATA_AFTER_VIDEO_EDIT,
    payload: payload,
  });
};

export const setHandleDeletedVideo = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.HANDLE_DELETED_VIDEO,
    payload: payload,
  });
};

export const setHandleVideoSelection = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.HANDLE_VIDEO_SELECTION,
    payload: payload,
  });
};

export const setOpenNameDialog = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_NAME_DIALOG,
    payload: payload,
  });
};

export const setSelectedTheme = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_THEME,
    payload: payload,
  });
};

export const setHighlightTitle = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_HIGHLIGHT_TITLE,
    payload: payload,
  });
};

export const setThemeImageUrl = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_THEME_IMAGE_URL,
    payload: payload,
  });
};

export const setShowToolkit = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SHOW_TOOLKIT,
    payload: payload,
  });
};

export const setShowToolkitSecond = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SHOW_TOOLKIT_SECOND,
    payload: payload,
  });
};

export const setToolkitUrl = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_TOOLKIT_URL,
    payload: payload,
  });
};

export const setThemeHighlightTitleColor = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_THEME_HIGHLIGHT_TITLE_COLOR,
    payload: payload,
  });
};

export const setThemePopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_THEME_POPUP,
    payload: payload,
  });
};

export const setIsOverlayText = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_IS_OVERLAY_TEXT,
    payload: payload,
  });
};

export const setShowSelectionToolkit = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SHOW_SELECTION_TOOLKIT,
    payload: payload,
  });
};

export const setThemeImageUrlSend = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_THEME_IMAGE_URL_SEND,
    payload: payload,
  });
};
